import React, { useState, useEffect } from 'react'
import { Row, Col, Table, Button, Form, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Card from "../../../components/Card";


const Data_table = [
  // {
  //   aCode: "",
  //   aGroup: "",
  //   aNumber: "",
  //   aName: "",
  //   group:"",
  //   metal:"",
  //   cPerson:"",
  //   cellNumber:"",
  //   msgMobileNum:"",
  //   panNumber:"",
  //   address:"",
  //   deliveryAdsress:"",
  //   openingCr:"",
  //   oCrWt:"",
  //   openingDr:"",
  //   oDrWt:"",
  //   dueDays:"",
  //   seal:"",
  //   tds:"",
  //   place:"",

  // },

  {
    aCode: "",
    aGroup: "",
    aNumber: "",
    aName: "",
    group: "",
    metal: "",
    cPerson: "",
    cellNumber: "",
    msgMobileNum: "",
    panNumber: "",
    address: "",
    deliveryAdsress: "",
    openingCr: "",
    oCrWt: "",
    openingDr: "",
    oDrWt: "",
    dueDays: "",
    seal: "",
    tds: "",
    place: "",

  },





];

const TableData = () => {

  const [show1, setShow1] = useState(false);
  const [sho, setSho] = useState(false);
  const [show, setShow] = useState(false);

  const handleClose1 = () => setShow1(false);
  //const handleShow1 = () => setShow1(true);
  const handleShow1 = (data) => {
    setShow1(true);
    if (data == 'add') {
      setSho('Add New');
      setShow('Save');
    } else {
      setSho('Edit');
      setShow('Update');
    }
  }
  const navigate = useNavigate();
  const BackToLotIssue = () => {
    navigate('../dashboard/table/TableDataTransactionLotIssue');
  };


  return (
    <>
      <Row>
        <Card>
          <Card.Header className="d-flex justify-content-between">
            <div className="header-title">
              <h4 className="card-title">Lot Issue Screen</h4>
            </div>
          </Card.Header>
          <Card.Body>
            <div className='container'>

              <div className='container-fluid'>
                <div className='col-md-12 col-lg-12 col-sm-12 col-xs-12'>
                  <div className='row'>
                    <div className=' col-md-4 col-md-3'>
                      <Form.Label>Lot Issue No.</Form.Label>
                      <Form.Control type="text" placeholder="" />
                    </div>
                    <div className=' col-md-4 col-md-3'>
                      <Form.Label>Pocket No.</Form.Label>
                      <Form.Control type="text" placeholder="" />
                    </div>
                    <div className=' col-md-4 col-md-3'>
                      <Form.Label>Issue Date</Form.Label>
                      <Form.Control type="text" placeholder="" />
                    </div>
                  </div>
                  <div className=' py-2 row'>
                    <div className=' col-md-6 col-md-4'>
                      <Form.Label>Branch</Form.Label>
                      <Form.Control type="text" placeholder="" />
                    </div>
                    <div className=' col-md-6 col-md-4'>
                      <Form.Label>Remark</Form.Label>
                      <Form.Control type="text" placeholder="" />
                    </div>
                  </div>
                  <div className=' py-2 row'>
                    <div className=' col-md-2 col-sm-3'>
                      <Form.Label>Stone Pcs</Form.Label>
                      <Form.Control type="text" placeholder="" />
                    </div>
                    <div className=' col-md-2 col-sm-3'>
                      <Form.Label>Stone Wt</Form.Label>
                      <Form.Control type="text" placeholder="" />
                    </div>
                    <div className=' col-md-2 col-sm-3'>
                      <Form.Label>Stone Amt</Form.Label>
                      <Form.Control type="text" placeholder="" />
                    </div>
                    <div className=' col-md-2 col-sm-3'>
                      <Form.Label>Gross Wt</Form.Label>
                      <Form.Control type="text" placeholder="" />
                    </div>
                    <div className=' col-md-2 col-sm-3'>
                      <Form.Label>Net Wt</Form.Label>
                      <Form.Control type="text" placeholder="" />
                    </div>
                    <div className=' col-md-2 col-sm-3'>
                      <Form.Label>Total Wt</Form.Label>
                      <Form.Control type="text" placeholder="" />
                    </div>

                  </div>

                  <div className=' py-2 row'>

                    <div className=' col-md-2 col-sm-3'>
                      <Form.Label>Pure Wt</Form.Label>
                      <Form.Control type="text" placeholder="" />
                    </div>
                    <div className=' col-md-2 col-sm-3'>
                      <Form.Label>Round Off</Form.Label>
                      <Form.Control type="text" placeholder="" />
                    </div>
                    <div className=' col-md-8 col-sm-3'>
                      <Form.Label>Grand Total</Form.Label>
                      <Form.Control type="text" placeholder="" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="table-responsive mt-2" >

                <Table striped id="basic-table" className="table-striped mb-0" role="grid">
                  <thead>
                    <tr>
                      <th>Lot No</th>
                      <th>ProductName</th>
                      <th>ItemName</th>
                      <th>Purity</th>
                      <th>Pcs</th>
                      <th>GrossWt</th>
                      <th>Excess Wt</th>
                      <th>MiscWt</th>
                      <th>NetWt</th>
                      <th>MC</th>
                      <th>Touch</th>
                      <th>Wastage</th>
                      <th>PureWt</th>
                      <th>StoneWt</th>
                      <th>StonePcs</th>
                      <th>StoneAmt</th>
                      <th>DiamondPcs</th>
                      <th>C.OrderNo</th>
                      <th>OtherCharges</th>
                      <th>HallMark</th>
                      <th>TotalAmt</th>
                      <th>PcsAmount</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>

                  </tbody>
                </Table>
              </div>
              <div className='pt-2' style={{ direction: 'rtl' }} >
                <Form.Group className="form-group">


                  <Button type="button" variant='btn btn-primary' >
                    <i className="btn-inner">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-printer" viewBox="0 0 16 16">
                        <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z" />
                        <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2H5zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4V3zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2H5zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1z" />
                      </svg>
                    </i>
                    <span>Print</span>
                  </Button>{' '}
                  <Button type="button" variant="btn btn-danger" onClick={BackToLotIssue}>cancel</Button> {' '}
                  <Button type="button" variant="btn btn-primary" onClick={BackToLotIssue}>Save</Button>
                </Form.Group>
              </div>
            </div>
          </Card.Body>
        </Card>
      </Row >
    </>
  );
};

export default TableData;
